import React from 'react';

import { WHAT_DRIVES_ME } from 'constants/texts';
import { SECTIONS } from 'constants/sections';

import Section from 'components/Section';

import './styles.scss';

function WhatDrivesMe() {
  return (
    <Section name={SECTIONS.WHAT_DRIVES_ME.name}>
      <div className="first-column">
        <h1 className="title">{WHAT_DRIVES_ME.title}</h1>
        <p className="paragraph">{WHAT_DRIVES_ME.content}</p>
      </div>
    </Section>
  )
}
export default WhatDrivesMe;
